import { IHistoryIsEmptyLang } from '../../../types/lang'
import { EHistoryIsEmpty } from '../../../types'

export const historyIsEmptyLang: IHistoryIsEmptyLang = {
	history_is_empty: {
		[EHistoryIsEmpty.NotEmpty]: 'Not Empty_ru',
		[EHistoryIsEmpty.Empty]: 'Empty_ru',
	}
}